import { render, staticRenderFns } from "./Dev.vue?vue&type=template&id=9622e954&scoped=true&"
import script from "./Dev.vue?vue&type=script&lang=js&"
export * from "./Dev.vue?vue&type=script&lang=js&"
import style0 from "./Dev.vue?vue&type=style&index=0&id=9622e954&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9622e954",
  null
  
)

export default component.exports